var sizePairs = /*#__PURE__*/function (sizePairs) {
  sizePairs["small"] = "sm";
  sizePairs["medium"] = "md";
  sizePairs["large"] = "lg";
  sizePairs["xlarge"] = "xl";
  return sizePairs;
}(sizePairs || {});

var convertLegacyModalSize = function convertLegacyModalSize(inputSize) {
  return sizePairs[inputSize] || inputSize;
};

export { convertLegacyModalSize };